<template>
    <section class="interview-title light green">
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-eva.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light green">
                    <h3>Interview Eva Hendriks</h3>
                    <h2>Belangrijke onderwerpen structureel op de agenda met hulp van de Ondernemingsraad en Gemeenschappelijke Medezeggenschapsraad</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .bg{
        background-position-y:100% !important;
    }
</style>

<script>
    import InterviewEva from '@/app/pages/sub/InterviewEva';

    export default {
        name: 'DuurzaamInterview',
        meta: {
            title: 'DuurzaamInterview',
            color: '#12C470'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewEva );
            }
        }
    };
</script>
